'use client';
import BlockHeader from '@/components/UIkit/BlockHeader';
import { useState, ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';
import ModalFormMC from '../Modal/ModalMC';
import LocalizedLink from '../LocalizedLink';

export interface NumHorizontalListBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  formatList: Array<{
    icon: string;
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
    list?: Array<string> | Array<{ item: ReactNode | SerializedEditorState }>;
  }>;
  linkBtn?: {
    enters: boolean;
    link: string;
    btnTxt: string;
  };
  showBtn?: boolean;
  btnTxt?: string;
  color?: 'green' | 'blue' | 'violet';
  btnTag?: string;
}

export default function NumHorizontalListBlock({
  title,
  formatList,
  id,
  subtitle,
  linkBtn,
  color = 'blue',
  title_2,
  showBtn,
  btnTxt,
  btnTag,
}: NumHorizontalListBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  const backgroundBtnColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';
  const borderColorClass =
    {
      green: 'border-[#0F645B]',
      blue: 'border-blue-100',
      violet: 'border-violet-100',
    }[color] || 'border-green-100';
  const txtColorClass =
    {
      green: 'text-[#0F645B]',
      blue: 'text-blue-100',
      violet: 'text-violet-100',
    }[color] || 'text-green-100';
  return (
    <>
      <div
        id={id}
        data-meta="NumHorizontalListBlock"
        className="container mx-auto px-4 sm:px-6 lg:px-8 my-14"
      >
        <BlockHeader title={title} subtitle={subtitle} />
        {title_2 && (
          <CustomRichText
            data={title_2}
            tag="div"
            className="text-3xl font-bold text-center mb-8 text-white"
          />
        )}
        <div className="flex flex-col lg:flex-row lg:flex-wrap">
          {formatList.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col flex-1 border-b lg:border-b-0 lg:border-l border-white/20 ${
                index === formatList.length - 1 ? '' : ''
              }`}
            >
              <div className="p-4">
                <div className={`font-bold text-white text-opacity-40 text-6xl mb-4`}>{item.icon}</div>
                <div className="mb-4">
                  <CustomRichText
                    data={item.title}
                    tag="div"
                    className="text-xl text-white font-bold"
                  />
                </div>
                <CustomRichText data={item.subtitle} tag="div" className="text-white" />
                {!!item.list?.length &&
                  item.list.map((listItem, idx) => (
                    <CustomRichText
                      key={idx}
                      data={typeof listItem === 'string' ? listItem : listItem.item}
                      tag="div"
                      className="text-white"
                    />
                  ))}
              </div>
            </div>
          ))}
        </div>
        {linkBtn?.enters && (
          <div className="flex justify-center mt-8">
            <LocalizedLink
              href={linkBtn.link}
              className={`${backgroundBtnColorClass} rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline`}
            >
              {linkBtn.btnTxt}
            </LocalizedLink>
          </div>
        )}
        {showBtn && (
          <div className="flex justify-center mt-8">
            <button
              onClick={openForm}
              className={`${backgroundBtnColorClass} rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline`}
            >
              {btnTxt}
            </button>
          </div>
        )}
        {isFormOpen && (
          //works only with marketing in CRM
          <ModalFormMC
            closeForm={closeForm}
            btnMeta={{
              tag: btnTag ?? 'партнерська-програма',
            }}
            color={color}
          />
        )}
      </div>
    </>
  );
}
